import React, {useState, useEffect} from "react"
import axios from '../../axiosConfig'
import ReactMarkdown from 'react-markdown'
import {
    Button,
    Container,
    Row,
    Col,
    Modal,
    ModalBody
} from "reactstrap"
import Navbar from "components/Navbar/Navbar.js"
import Footer from "components/Footer/Footer.js"

function Project(props) {
    const [descriptionModal,
        setDescriptionModal] = React.useState({data: {}, open: false})
    const [data,
        setData] = useState({project: {}})

    function handleDescription(data) {
        setDescriptionModal({data: data, open: true})
    }

    useEffect(() => {
        const fetchData = async() => {
            const result = await axios("projects/" + props.match.params.id + ".json")
            setData(result.data)
        }
        fetchData()
    }, [props.match.params.id])

    useEffect(() => {
        document
            .body
            .classList
            .add("landing-page")
        document
            .body
            .classList
            .add("sidebar-collapse")
        document
            .documentElement
            .classList
            .remove("nav-open")
        if (window.innerWidth > 991) {
            return function cleanup() {
                document
                    .body
                    .classList
                    .remove("landing-page")
                document
                    .body
                    .classList
                    .remove("sidebar-collapse")
            }
        }
    })
    return ( <> {
        descriptionModal.data
            ? <Modal
                    size="lg"
                    style={{
                    marginTop: "-100px"
                }}
                    isOpen={descriptionModal.open}
                    toggle={() => setDescriptionModal({open: false})}>
                    <div className="modal-header justify-content-center">
                        <button
                            className="close"
                            type="button"
                            onClick={() => setDescriptionModal({open: false})}>
                            <i className="now-ui-icons ui-1_simple-remove"></i>
                        </button>

                        <h3 className="title title-up">{(descriptionModal.data.firstName && descriptionModal.data.lastName)
                                ? (descriptionModal.data.firstName + " " + descriptionModal.data.lastName)
                                : null}</h3>
                    </div>
                    <ModalBody className="" md="12">
                        <Container>
                            <Row>
                                <Col>
                                    <div
                                        className="ml-auto mr-auto text-center"
                                        style={{
                                        padding: "15px",
                                        maxHeight: "150px",
                                        maxWidth: "150px"
                                    }}>
                                        {descriptionModal.data.avatar
                                            ? (<img
                                                alt="..."
                                                className="rounded-circle img-fluid img-raised"
                                                src={descriptionModal.data.avatar}/>)
                                            : (<img
                                                alt="..."
                                                className="rounded-circle img-fluid img-raised"
                                                src={require("assets/img/avatar.png")}/>)}
                                    </div>
                                </Col>
                            </Row>

                            <Row>

                                <Col className="ml-auto mr-auto text-center" md="8">
                                    <p
                                        style={{
                                        color: "black"
                                    }}>{descriptionModal.data.description}</p>
                                    <Button
                                        className="btn-icon btn-round"
                                        color={descriptionModal.data.linkedin
                                        ? "info"
                                        : null}
                                        target="_blank"
                                        href={descriptionModal.data.linkedin
                                        ? descriptionModal.data.linkedin
                                        : "/"}
                                        disabled={!descriptionModal.data.linkedin}
                                        >
                                        <i className="fab fa-linkedin"/>
                                    </Button>
                                    <Button
                                        className="btn-icon btn-round"
                                        color={descriptionModal.data.github
                                        ? "info"
                                        : null}
                                        target="_blank"
                                        href={descriptionModal.data.github
                                        ? descriptionModal.data.github
                                        : "/"}
                                        disabled={!descriptionModal.data.github}
                                        >
                                        <i className="fab fa-github-square"/>
                                    </Button>
                                </Col>
                            </Row>
                        </Container>
                    </ModalBody>
                </Modal>
            : null
    } < Navbar /> <div className="section text-center">
            <Container>
                <h1 className="title">{data.name}</h1>
                <ReactMarkdown source={data.description}/>
            </Container>
            <Container>
                <div className="d-flex flex-col justify-content-center">
                    <iframe
                        src={data.youtube}
                        style={{
                        width: "80%",
                        height: "500px",
                        border: 0
                    }}
                        allowFullScreen
                        allow="accelerometer encrypted-media gyroscope picture-in-picture"
                        title="video"/>
                </div>
            </Container>
        </div>
        {
        data.members
            ? (
                <div className="section-team text-center">
                    <Container>
                        <h2 className="title">Team Members</h2>
                        <div className="team">
                            <Row>
                                {Object
                                    .values(data.members)
                                    .map((item) => {
                                        return (
                                            <Col
                                                key={item.firstName + item.lastName}
                                                md={3}
                                                style={{
                                                height: "300px"
                                            }}>
                                                <div className="team-player">
                                                    <div
                                                        style={{
                                                        marginBottom: "-40px",
                                                        minHeight: "100px",
                                                        minWidth: "100px",
                                                    }}>
                                                        {item.avatar
                                                            ? (<img
                                                                style={{
                                                                    minHeight: "100px",
                                                                    minWidth: "100px",
                                                                    maxHeight: "100px",
                                                                    maxWidth: "100px",
                                                                }}
                                                                alt="..."
                                                                className="rounded-circle img-fluid img-raised"
                                                                src={item.avatar}/>)
                                                            : (<img
                                                                alt="..."
                                                                className="rounded-circle img-fluid img-raised"
                                                                src={require("assets/img/avatar.png")}/>)}
                                                    </div>
                                                    <h4 className="title">{item.firstName
                                                            ? item.firstName
                                                            : "First Name"}</h4>
                                                    <p
                                                        className="category text-info"
                                                        style={{
                                                        marginTop: "-15px"
                                                    }}>{item.lastName
                                                            ? item.lastName
                                                            : "Last Name"}</p>
                                                    <p
                                                        className="description"
                                                        style={{
                                                        marginTop: "-10px",
                                                        color: "black"
                                                    }}>
                                                        {item.description
                                                            ? (item.description.length > 30
                                                                ? item.description.substring(0, 29) + " ..."
                                                                : item.description)
                                                            : "Concordia Student"}
                                                    </p>
                                                    <div
                                                        style={{
                                                        marginTop: "-15px"
                                                    }}>
                                                        <Button
                                                            className="btn-icon btn-round"
                                                            color={item.linkedin
                                                            ? "info"
                                                            : null}
                                                            target="_blank"
                                                            href={item.linkedin
                                                            ? item.linkedin
                                                            : "/"}
                                                            disabled={!item.linkedin}>
                                                            <i className="fab fa-linkedin"/>
                                                        </Button>
                                                        <Button
                                                            className="btn-icon btn-round"
                                                            color={item.github
                                                            ? "info"
                                                            : null}
                                                            target="_blank"
                                                            href={item.github
                                                            ? item.github
                                                            : "/"}
                                                            disabled={!item.github}>
                                                            <i className="fab fa-github-square"/>
                                                        </Button>
                                                        {(item.description && item.description.length > 30)
                                                            ? (
                                                                <Button
                                                                    onClick={() => handleDescription(item)}
                                                                    className="btn-icon btn-round"
                                                                    color="info"
                                                                    type="button">
                                                                    <i className="now-ui-icons travel_info"></i>
                                                                </Button>
                                                            )
                                                            : null}
                                                    </div>
                                                </div>
                                            </Col>
                                        )
                                    })}
                            </Row>
                        </div>
                    </Container>
                </div>
            )
            : null
    } < Footer /> </>)
}

export default Project
